import DigitalSkilling from "./DigitalSkilling.js";
import FeaturesSection from "./FeaturesSection.js";
import LearningHub from "./LearningHub.js";
import LearningSection from "./LearningSection.js";

const LearningHubIndex = () => {
  return (
    <div>
      <LearningHub />
      <FeaturesSection />
      <DigitalSkilling />
      {/* <SmiklearnPromo /> */}
      <LearningSection />
    </div>
  );
};

export default LearningHubIndex;
